var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding-top-5xl", attrs: { id: "tech" } },
    [
      _c("div", { staticClass: "row margin-bottom-4xl" }, [
        _c("div", { staticClass: "column-12 text-center" }, [
          _c(
            "h2",
            {
              staticClass: "text-uppercase size-md with-anchor",
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-3xl)",
                "font-weight": "var(--font-weight-black)",
                color: "var(--fa-dk-violet)",
              },
            },
            [
              _c("anchor-link", {
                attrs: {
                  anchor: "#tech",
                  "link-color": "violet",
                  "anchor-name": "Tech Updates",
                },
              }),
              _vm._v("\n        Only the Freshest Ingredients\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _c("h1", { staticClass: "h2 margin-y-md" }, [_vm._v("Tech Updates")]),
          _vm._v(" "),
          _c("p", { staticClass: "line-length-xl margin-auto" }, [
            _vm._v(
              "\n        With Font Awesome 7, we've made huge improvements to how icons work behind the scenes. From minor tweaks to major overhauls, our toolkit is now faster\n        than ever.\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: { "--card-vertical-padding": "var(--spacing-2xl)" },
        },
        [
          _c("div", { staticClass: "column-6 laptop:column-3" }, [
            _c(
              "div",
              { staticClass: "card violet inverted header with-top-tag" },
              [
                _c("span", { staticClass: "tag top teal" }, [_vm._v("New!")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header" },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: _vm.$v7.solid.faGaugeMax, size: "2x" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column-6 laptop:column-3" }, [
            _c("div", { staticClass: "card with-top-tag" }, [
              _c("span", { staticClass: "tag top teal" }, [_vm._v("New!")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header inverted" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v7.solid.faArrowRotateRight,
                      size: "2x",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column-6 laptop:column-3" }, [
            _c(
              "div",
              { staticClass: "card violet inverted header with-top-tag" },
              [
                _c("span", { staticClass: "tag top teal" }, [_vm._v("New!")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header" },
                  [
                    _c("font-awesome-icon", {
                      attrs: {
                        icon: _vm.$v7.solid.faArrowsLeftRightToLine,
                        size: "2x",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(2),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column-6 laptop:column-3" }, [
            _c("div", { staticClass: "card with-top-tag" }, [
              _c("span", { staticClass: "tag top teal" }, [_vm._v("New!")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header inverted" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v7.solid.faUniversalAccess,
                      size: "2x",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(3),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "column-12 laptop:column-4 display-flex flex-column align-stretch flex-content-between",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "card roomy blue tablet:display-flex laptop:display-block",
              },
              [
                _vm._m(4),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { flex: "1" } },
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/apis/javascript") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_api_get_started_link_click"
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-blue)" },
                          attrs: {
                            icon: _vm.$v7.solid.faPuzzle,
                            "fixed-widt": "",
                            size: "lg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Components for JS Frameworks")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web/setup/use-kit") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_use_kit_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-blue)" },
                          attrs: { icon: _vm.$v7.solid.faGlobe, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Hosted CDN Options")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web/setup/packages") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_packages_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-blue)" },
                          attrs: { icon: _vm.$v7.solid.faBox, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Install via Package Managers")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/apis/graphql") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_apis_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-blue)" },
                          attrs: { icon: _vm.$v7.solid.faPlug, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Official GraphQL API")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_web_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-blue)" },
                          attrs: {
                            icon: _vm.$v7.solid.faBracketsCurly,
                            size: "lg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("CSS Framework")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 laptop:column-4 display-flex flex-column align-stretch flex-content-between",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "card roomy violet tablet:display-flex laptop:display-block",
              },
              [
                _vm._m(5),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { flex: "1" } },
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$search() },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:icon_search_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-violet)" },
                          attrs: { icon: _vm.$v7.solid.faIcons, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Thousands of Icons")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web/add-icons/upload-icons") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_upload_icons_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-violet)" },
                          attrs: {
                            icon: _vm.$v7.solid.faCloudUpload,
                            size: "lg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Upload Your Own Icons")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web/setup/use-kit") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_use_kit_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-violet)" },
                          attrs: { icon: _vm.$v7.solid.faSuitcase, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Easy Development Hand-off")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: {
                          to: _vm.$docs("/desktop/add-icons/ligatures"),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_ligatures_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-violet)" },
                          attrs: { icon: _vm.$v7.solid.faTextSize, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Text-to-Icon Ligatures")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: {
                          href: "https://www.figma.com/community/file/1529485083934388018/font-awesome-7-icon-component",
                          target: "_blank",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:figma_component_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-violet)" },
                          attrs: { icon: _vm.$v7.brands.faFigma, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Figma Component")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "column-12 laptop:column-4 display-flex flex-column align-stretch flex-content-between",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "card roomy teal tablet:display-flex laptop:display-block",
              },
              [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { flex: "1" } },
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web/setup/use-kit") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_use_kit_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-teal)" },
                          attrs: { icon: _vm.$v7.solid.faGlobe, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Easy Install + Hosting")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web/style/styling") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_styling_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-teal)" },
                          attrs: { icon: _vm.$v7.solid.faPalette, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Styling Shortcuts")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: { to: _vm.$docs("/web/use-with/wordpress") },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:docs_wordpress_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-teal)" },
                          attrs: { icon: _vm.$v7.solid.faHashtag, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Wordpress Plugin")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: {
                          to: _vm.$search({ iconCollections: ["free"] }),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:free_icon_search_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-teal)" },
                          attrs: { icon: _vm.$v7.solid.faHeart, size: "lg" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Open Source Options")]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "site-link",
                      {
                        staticClass: "display-flex align-middle padding-y-sm",
                        attrs: {
                          to: _vm.$search({ iconCollections: ["brands"] }),
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "home:brands_icon_search_link_click",
                              { location: "tools" }
                            )
                          },
                        },
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "padding-right-sm",
                          staticStyle: { color: "var(--fa-dk-teal)" },
                          attrs: {
                            icon: _vm.$v7.brands.faFontAwesome,
                            size: "lg",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Popular Brand Icons")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("h4", { staticClass: "h5" }, [_vm._v("Faster Load Times!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("Refined SVG/JS, optimized font files, and compressed CSS."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("h4", { staticClass: "h5" }, [_vm._v("Toolkit Updates!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Upgraded to Dart Sass with modern SCSS and improved CSS properties."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("h4", { staticClass: "h5" }, [_vm._v("Consistent Icon Widths!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          'Icon canvases now render at a fixed width, with new "automatic" option.'
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-left" }, [
      _c("h4", { staticClass: "h5" }, [_vm._v("Improved Accessibility!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Better screen reader support, assistive tech, and RTL compatibility."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "display-flex align-middle align-center flex-column",
        staticStyle: { flex: "1" },
      },
      [
        _c("img", {
          staticClass: "margin-auto padding-md",
          attrs: {
            src: "https://img.fortawesome.com/1ce05b4b/badge-code.svg",
            alt: "decorative code badge",
          },
        }),
        _vm._v(" "),
        _c(
          "h4",
          {
            staticClass: "margin-y-xl",
            staticStyle: { color: "var(--fa-navy)" },
          },
          [_vm._v("\n            Great for Developers\n          ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "display-flex align-middle align-center flex-column",
        staticStyle: { flex: "1" },
      },
      [
        _c("img", {
          staticClass: "margin-auto padding-md",
          attrs: {
            src: "https://img.fortawesome.com/1ce05b4b/badge-pen-nib.svg",
            alt: "decorative pen nib badge",
          },
        }),
        _vm._v(" "),
        _c(
          "h4",
          {
            staticClass: "margin-y-xl",
            staticStyle: { color: "var(--fa-navy)" },
          },
          [_vm._v("\n            Great for Designers\n          ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "display-flex align-middle align-center flex-column",
        staticStyle: { flex: "1" },
      },
      [
        _c("img", {
          staticClass: "margin-auto padding-md",
          attrs: {
            src: "https://img.fortawesome.com/1ce05b4b/badge-file.svg",
            alt: "decorative content badge",
          },
        }),
        _vm._v(" "),
        _c(
          "h4",
          {
            staticClass: "margin-y-xl",
            staticStyle: { color: "var(--fa-navy)" },
          },
          [_vm._v("\n            Great for Content Creators\n          ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }